import { GridColumnProps } from "@progress/kendo-react-grid";
import { CLASSNAME } from "utils/constant";
import { GrideDateFormatter } from "ui/Date";
import { NumericalCell, NumericalHeader } from "ui/grid/GridCommandCell";
import CellPopover from "ui/grid/DescriptionCell";
import { t } from "i18next";

export const quotaTransactionGridColumnItem = () => {
	const handleColor = (amount: number) => {
		if (amount < 0) {
			return "red";
		}
		return undefined;
	};
	const gridItems: GridColumnProps[] = [
		{
			field: "valueTime",
			title: t("Date"),
			headerClassName: "no-border",
			width: "120px",
			cell: (props) => (
				<GrideDateFormatter
					date={props.dataItem.valueTime}
					formatType={"dd.MM.yyyy"}
				/>
			),
		},
		{
			field: "weekNo",
			title: t("Period"),
			width: "90px",
			headerClassName: "no-border",
		},
		{
			field: "balanceTypeText",
			title: t("Description"),
			headerClassName: "no-border",
			cell: (props) => <CellPopover {...props} />,
		},
		{
			field: "documentNumber",
			title: "Ref/Seddelnr",
			width: "130px",
			headerClassName: "no-border",
		},
		{
			field: "catchType",
			title: t("Catch") + " " + t("Type"),
			width: "130px",
			headerClassName: "no-border",
			cell: (props) => (
				<td>
					<span>{props.dataItem.catchType}</span>
					{props.dataItem.catchType && props.dataItem.conservationType && (
						<span style={{ margin: "0 8px" }}></span>
					)}
					<span>{props.dataItem.conservationType}</span>
				</td>
			),
		},
		{
			field: "amount",
			title: t("Quota") + " " + t("Weight"),
			width: "130px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => (
					<NumericalCell
						{...props}
						style={{ color: handleColor(props.dataItem.amount) }}
					/>
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "catchAmountToDate",
			title: t("Weight") + " " + t("Sofar"),
			width: "130px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "availableRemainingQuota",
			title: t("Remaining") + " " + t("Quota"),
			width: "130px",
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
			cells: {
				data: (props) => <NumericalCell {...props} />,
				headerCell: (props) => <NumericalHeader {...props} />,
			},
		},
		{
			field: "extraQuotaId",
			title: "Tillegg",
			width: "120px",
			headerClassName: "no-border",
		},
		{
			field: "illegalDirectWarning",
			title: "DFV",
			width: "100px",
			headerClassName: "no-border",
		},
		{
			field: "illegalCatchWarning",
			title: "UFV",
			width: " 100px",
			headerClassName: "no-border",
		},
		{
			field: "fishingStatus",
			title: t("Fishing") + " " + t("Status"),
			width: "120px",
			headerClassName: "no-border",
		},
	];
	return gridItems;
};
